import { isFullyLoaded } from "../../../selectors/itemStateSelectors";

const hasDuplicateItemIds = (incomingItems, items) => {
  const loadedItems = items.filter(isFullyLoaded);

  return incomingItems.some(({ id: incomingId }) =>
    loadedItems.some(({ id }) => id === incomingId)
  );
};

export default hasDuplicateItemIds;
